import { createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/camera.svg'
import _imports_1 from '@/assets/img/folder.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-6cfd4310")

_pushScopeId("data-v-6cfd4310")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "uploadPhotoModal" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_8 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_ctx.mobile)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", {
          class: "uploadPhotoBackground",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('hide')))
        }, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", {
                class: "col-6",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.getPic(1)), ["stop","prevent"]))
              }, [
                _createVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createVNode("p", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: 'app_fotocamera',
                      text: 'Camera'
                    })
                  ])
                ])
              ]),
              _createVNode("div", {
                class: "col-6",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.getPic(0)), ["stop","prevent"]))
              }, [
                _createVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode("p", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: 'app_gallery',
                      text: 'Gallery'
                    })
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createBlock("div", _hoisted_8, [
        _createVNode("input", {
          type: "file",
          onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.changedFile && _ctx.changedFile(...args))),
          hidden: "",
          ref: "input_file"
        }, null, 544)
      ]))
})